import { render, staticRenderFns } from "./FrrOutro.vue?vue&type=template&id=4aebff40&scoped=true&"
import script from "./FrrOutro.vue?vue&type=script&lang=js&"
export * from "./FrrOutro.vue?vue&type=script&lang=js&"
import style0 from "./FrrOutro.sass?vue&type=style&index=0&id=4aebff40&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebff40",
  null
  
)

export default component.exports